import React from 'react';
import { STATUS_LABELS, PROJECT_STATUS_LABELS, projectCode, taskCode, userDisplayName, formatDate } from './helpers';

const STATUS_ORDER = ['Todo', 'In_Progress', 'In_Review', 'Done', 'Blocked'];

function ProjectReport({ project, tasks, users, deliverableCount }) {
  const counts = {};
  STATUS_ORDER.forEach((s) => { counts[s] = tasks.filter((t) => t.status === s).length; });

  const manager = users.find((u) => u.id === project.project_manager_id);
  const budgetPct = project.budget_allocated ? Math.round((project.budget_spent / project.budget_allocated) * 100) : 0;

  return (
    <div>
      <div className="page-header-row">
        <h2 style={{ margin: 0 }}>Rapport détaillé — {project.name}</h2>
        <button className="btn btn-primary" onClick={() => window.print()}>Exporter en PDF</button>
      </div>

      <div className="report-card">
        <div className="report-card-top">
          <div>
            <span className="project-ref">{projectCode(project.id)}</span>{' '}
            <span className="badge badge-active">{PROJECT_STATUS_LABELS[project.status] || project.status}</span>
            <div className="project-title">{project.name}</div>
            <div className="project-meta">{project.description}</div>
          </div>
          <div>
            <div className="report-pct">{project.progress_percent}%</div>
            <div className="report-pct-label">avancement</div>
          </div>
        </div>

        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${project.progress_percent}%` }} />
        </div>

        <div className="report-footer" style={{ flexWrap: 'wrap', gap: 24 }}>
          <div>
            <div className="detail-stat-label">Chef de projet</div>
            <div>{userDisplayName(manager)}</div>
          </div>
          <div>
            <div className="detail-stat-label">Période</div>
            <div>{formatDate(project.start_date)} → {formatDate(project.end_date)}</div>
          </div>
          <div>
            <div className="detail-stat-label">Budget alloué</div>
            <div>{(project.budget_allocated / 1000000).toFixed(2)} M MAD</div>
          </div>
          <div>
            <div className="detail-stat-label">Budget dépensé</div>
            <div>{(project.budget_spent / 1000000).toFixed(2)} M MAD ({budgetPct}%)</div>
          </div>
          <div>
            <div className="detail-stat-label">Livrables / documents</div>
            <div>{deliverableCount}</div>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: 16 }}>
        <h2>Répartition des tâches ({tasks.length} au total)</h2>
        {STATUS_ORDER.map((s) => (
          <div key={s} className="progress-row" style={{ marginTop: 10 }}>
            <span>{STATUS_LABELS[s]}</span>
            <span>{counts[s]}</span>
          </div>
        ))}
        {STATUS_ORDER.map((s) => (
          <div key={s} className="progress-bar" style={{ marginBottom: 6 }}>
            <div
              className="progress-fill"
              style={{ width: tasks.length ? `${(counts[s] / tasks.length) * 100}%` : '0%' }}
            />
          </div>
        ))}
      </div>

      <div className="table-container" style={{ marginTop: 16 }}>
        <table>
          <thead>
            <tr>
              <th>Réf.</th>
              <th>Tâche</th>
              <th>Responsable</th>
              <th>Statut</th>
              <th>Échéance</th>
              <th>Avancement</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map((t) => (
              <tr key={t.id}>
                <td>{taskCode(t.id)}</td>
                <td>{t.name}</td>
                <td>{userDisplayName(users.find((u) => u.id === t.assigned_to))}</td>
                <td>{STATUS_LABELS[t.status] || t.status}</td>
                <td>{formatDate(t.due_date)}</td>
                <td>{t.progress_percent || 0}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ProjectReport;
